<template>
    <svg viewBox="0 0 120 120">
  <!-- 上方箭头 -->
  <polyline 
    points="20,100 70,60 120,100" 
    stroke="white" 
    stroke-width="5" 
    fill="none" 
    stroke-linecap="round" 
    stroke-linejoin="round" 
  />
  
  <!-- 下方箭头 -->
  <polyline 
    points="20,60 70,20 120,60" 
    stroke="white" 
    stroke-width="5" 
    fill="none" 
    stroke-linecap="round" 
    stroke-linejoin="round" 
  />
</svg>
</template>